export default __webpack_public_path__ + "3dd85a395bca46e79fe48a3c1708ce30.svg";